import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { UnarchivePagesMutationVariables } from '../src/__types__/UnarchivePagesMutation.ts';
import type { ArchiveDialogProps } from '../src/ArchiveProcessContainer.tsx';

export const UnarchivePagesDialogLoader: LoadableType<
	{
		contentId: string;
		onPageRestore?: () => void;
		source: ArchiveDialogProps<UnarchivePagesMutationVariables>['source'];
	} & DialogsContainerProps
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-UnarchivePagesLoader" */ '../src/UnarchivePagesLoader.tsx'
			)
		).UnarchivePagesLoader,
});
